export default "__VITE_ASSET__4908d61c__"